import FFLogins from './FFLogins';

export default FFLogins;